import { Box, Typography } from '@mui/material';
import styles from './no-referrals.module.css';

export default function NoReferrals({ cmsData }): JSX.Element {
  return (
    <section className={styles.noReferrals}>
      {cmsData?.image ? (
        <img
          src={cmsData.image}
          className={styles.image}
          alt="People communicating a message through a megaphone"
          data-core-qa="NoReferrals_image"
        />
      ) : null}
      <Typography variant="h3" data-core-qa="NoReferrals_heading">
        {cmsData.title}
      </Typography>
      <Box sx={{ marginTop: '16px' }}>
        <Typography variant="h4" data-core-qa="NoReferrals_subheading">
          {cmsData.subTitle}
        </Typography>
      </Box>
    </section>
  );
}
